/**
 * @interface Route
 *
 * @param { String } icon - mdi icon
 * @param { String } customIcon - custom svg icons added at '@/icons'
 * @param { String } name - route name
 * @param { String } path - path for route
 * @param { Boolean } hidden - visibility in drawer by style display
 * @param { Boolean } dontExist - visibility in drawer by VNode life cycle
 * @param { Array<Route> } children - children route
 * @param { Boolean } disabled - won't push route when true
 * @param { Boolean } expandable - expandable
 */

export const mrRoutes = [
  {
    icon: '',
    name: '',
    text: '',
    path: '/vip/',
    component: () => import('../mrPage/index.vue'),
    redirect: '/vip/overview',
    hidden: true,
    children: [
      {
        icon: 'mdi-home-variant-outline',
        name: 'mr-overview',
        text: 'routes.MR_HOME',
        path: '/vip/overview',
        component: () => import('../mrPage/overview.vue')
      },

      {
        icon: 'mdi-format-list-bulleted-triangle',
        name: 'mr-collect',
        text: 'routes.MR_COLLECT',
        expandable: true,
        path: '/vip/collect',
        redirect: '/vip/collect/charge',
        component: () => import('../mrPage/collect/index.vue'),
        children: [
          {
            icon: 'mdi-circle-outline',
            name: 'mr-collect-charge',
            text: 'routes.MR_COLLECT_CHARGE',
            path: '/vip/collect/charge',
            component: () => import('../mrPage/collect/charge.vue')
          }
        ]
      },

      {
        icon: 'mdi-format-list-bulleted-type',
        name: 'mr-order',
        text: 'routes.MR_ORDER',
        expandable: true,
        path: '/vip/order',
        redirect: '/vip/order/collect',
        component: () => import('../mrPage/order/index.vue'),
        children: [
          {
            icon: 'mdi-circle-outline',
            name: 'mr-order-collect',
            text: 'routes.MR_ORDER_COLLECT',
            path: '/vip/order/collect',
            component: () => import('../mrPage/order/collect.vue')
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-order-not-processed',
            text: 'routes.MR_ORDER_NOT_PROCESSED',
            path: '/vip/order/not-processed',
            component: () => import('../mrPage/order/not-processed.vue')
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-order-pay',
            text: 'routes.MR_ORDER_PAY',
            showPath: true,
            path: '/vip/order/pay',
            component: () => import('../mrPage/order/pay.vue'),
            children: [
              {
                icon: 'mdi-circle-outline',
                name: 'mr-order-history',
                text: 'routes.MR_HISTORY',
                path: '/vip/order/history/:bank_card_no',
                hidden: true,
                component: () => import('../mrPage/order/_card_number.vue')
              }
            ]
          }
        ]
      },

      {
        icon: 'mdi-currency-usd',
        name: 'mr-financial',
        text: 'routes.MR_FINANCIAL',
        expandable: true,
        path: '/vip/financial',
        redirect: '/vip/financial/history',
        component: () => import('../mrPage/financial/index.vue'),
        children: [
          {
            icon: 'mdi-circle-outline',
            name: 'mr-funding-history',
            text: 'routes.MR_FUNDING_HISTORY',
            path: '/vip/financial/history',
            component: () => import('../mrPage/financial/history.vue')
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-frozen',
            text: 'routes.MR_FROZEN',
            path: '/vip/financial/frozen',
            component: () => import('../mrPage/financial/frozen.vue')
          }
        ]
      },

      {
        icon: 'mdi-tune-vertical-variant',
        name: 'mr-withdrawal',
        text: 'routes.MR_WITHDRAWAL',
        expandable: true,
        path: '/vip/pay',
        redirect: '/vip/pay/request',
        component: () => import('../mrPage/pay/index.vue'),
        children: [
          {
            icon: 'mdi-circle-outline',
            name: 'mr-withdrawal-request',
            text: 'routes.MR_WITHDRAWAL_REQUEST',
            path: '/vip/pay/request',
            component: () => import('../mrPage/pay/request.vue')
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-withdrawal-history',
            text: 'routes.MR_WITHDRAWAL_HISTORY',
            path: '/vip/pay/history',
            showPath: true,
            component: () => import('../mrPage/pay/history.vue'),
            children: [
              {
                icon: 'mdi-circle-outline',
                name: 'mr-withdrawal-history-detail',
                text: 'routes.MR_HISTORY',
                path: '/vip/pay/history/:bank_card_no',
                hidden: true,
                component: () => import('../mrPage/pay/_card_number.vue')
              }
            ]
          }
        ]
      },

      {
        icon: 'mdi-transit-detour',
        name: 'mr-channel',
        text: 'routes.MR_CHANNEL',
        expandable: true,
        path: '/vip/channel',
        redirect: '/vip/channel/fee',
        component: () => import('../mrPage/channel/index.vue'),
        children: [
          // {
          //   icon: 'mdi-circle-outline',
          //   name: 'mr通道費率',
          //   text: '通道費率',
          //   path: '/vip/channel/fee',
          //   component: () => import('../mrPage/channel/fee.vue')
          // },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-success-rate',
            text: 'routes.MR_SUCCESS_RATE',
            path: '/vip/channel/success-rate',
            showPath: true,
            component: () => import('../mrPage/channel/success-rate.vue'),
            children: [
              {
                icon: 'mdi-circle-outline',
                name: 'mr-sub-accounts',
                text: 'routes.MR_SUB_ACCOUNTS',
                path: '/vip/channel/success-rate/:channel_type_id',
                hidden: true,
                component: () => import('../mrPage/channel/_channel_type.vue')
              }
            ]
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-api-docs',
            text: 'routes.MR_API_DOCS',
            path: '/vip/channel/api-docs',
            component: () => import('../mrPage/channel/api-docs.vue')
          }
        ]
      },

      {
        icon: 'mdi-chart-line',
        name: 'mr-merchant-info',
        text: 'routes.MR_MERCHANT_INFO',
        expandable: true,
        path: '/vip/info',
        redirect: '/vip/info/details',
        component: () => import('../mrPage/info/index.vue'),
        children: [
          {
            icon: 'mdi-circle-outline',
            name: 'mr-merchant-details',
            text: 'routes.MR_MERCHANT_INFO',
            path: '/vip/info/details',
            component: () => import('../mrPage/info/details.vue')
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-login-password',
            text: 'routes.MR_LOGIN_PASSWORD',
            path: '/vip/info/login-password',
            component: () => import('../mrPage/info/login-password.vue')
          },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-pay-password',
            text: 'routes.MR_PAY_PASSWORD',
            path: '/vip/info/pay-password',
            component: () => import('../mrPage/info/pay-password.vue')
          }
        ]
      }
    ]
  },

  {
    icon: '',
    name: 'mr-system',
    text: 'routes.MR_SYSTEM',
    path: '/vip/system',
    redirect: '/vip/system/access',
    component: () => import('../mrPage/system.vue'),
    children: [
      // {
      //   icon: 'mdi-circle',
      //   name: 'mr權限管理',
      //   text: '權限管理',
      //   path: '/vip/system/access',
      //   redirect: '/vip/system/access/users',
      //   expandable: true,
      //   component: () => import('../mrPage/system/access/index.vue'),
      //   children: [
      //     {
      //       icon: 'mdi-circle-outline',
      //       name: 'mr人員列表',
      //       text: '人員列表',
      //       path: '/vip/system/access/users',
      //       component: () => import('../mrPage/system/access/users.vue')
      //     },
      //     {
      //       icon: 'mdi-circle-outline',
      //       name: 'mr角色管理',
      //       text: '角色管理',
      //       path: '/vip/system/access/roles',
      //       component: () => import('../mrPage/system/access/roles.vue')
      //     }
      //   ]
      // },
      {
        icon: 'mdi-circle',
        name: 'mr-system-management',
        text: 'routes.MR_SYSTEM_MANAGEMENT',
        path: '/vip/system/logs',
        redirect: '/vip/system/logs/login-log',
        expandable: true,
        component: () => import('../mrPage/system/logs/index.vue'),
        children: [
          {
            icon: 'mdi-circle-outline',
            name: 'mr-login-log',
            text: 'routes.MR_LOGIN_LOG',
            path: '/vip/system/logs/login-log',
            component: () => import('../mrPage/system/logs/login-log.vue')
          },
          // {
          //   icon: 'mdi-circle-outline',
          //   name: 'mr操作日誌',
          //   text: '操作日誌',
          //   path: '/vip/system/logs/action-log',
          //   component: () => import('../mrPage/system/logs/action-log.vue')
          // },
          {
            icon: 'mdi-circle-outline',
            name: 'mr-system-version',
            text: 'routes.MR_SYSTEM_VERSION',
            path: '/vip/system/logs/version',
            component: () => import('../mrPage/system/logs/version.vue')
          }
        ]
      }
    ]
  }
];
